import Cookies from "js-cookie";

export default function ({ redirect, route }) {
  if (!Cookies.get("userId") && route.name === "dashboard") {
    redirect("/login");
  }
  if (!Cookies.get("userId") && route.name === "editprofile") {
    redirect("/login");
  }
  if (Cookies.get("userId") && route.name === "login") {
    redirect("/dashboard");
  }
  if (Cookies.get("isAdmin") !== "1" && route.name === "adminPanel") {
    redirect("/dashboard");
  }
  if (Cookies.get("role") !== "1" && route.name === "scientificProject") {
    redirect("/dashboard");
  }
}
